import { LifecycleStatus, PortfolioType } from '@ndvr/portfolio-api';

import { TagTypes } from 'widgets/Tag';

export const PORTFOLIO_TYPE_TAG_MAP: { [key in PortfolioType]: TagTypes } = {
    [PortfolioType.DRAFT]: 'neutral',
    [PortfolioType.CLOSED]: 'negative',
    [PortfolioType.ONBOARDING]: 'neutral',
    [PortfolioType.REAL]: 'positive',
};

export const PORTFOLIO_TYPE_DISPLAY_MAP: { [key in PortfolioType]: string } = {
    [PortfolioType.DRAFT]: 'draft',
    [PortfolioType.CLOSED]: 'closed',
    [PortfolioType.ONBOARDING]: 'onboarding',
    [PortfolioType.REAL]: 'live',
};

export const LIFECYCLE_TYPE_TAG_MAP: { [key in LifecycleStatus]: TagTypes } = {
    [LifecycleStatus.DRAFT]: 'neutral',
    [LifecycleStatus.CLOSED]: 'negative',
    [LifecycleStatus.ONBOARDING]: 'neutral',
    [LifecycleStatus.REAL]: 'positive',
};

export const LIFECYCLE_TYPE_DISPLAY_MAP: { [key in LifecycleStatus]: string } = {
    [LifecycleStatus.DRAFT]: 'draft',
    [LifecycleStatus.CLOSED]: 'closed',
    [LifecycleStatus.ONBOARDING]: 'onboarding',
    [LifecycleStatus.REAL]: 'live',
};
